import React from 'react';
import { Mail, Phone, User, MessageSquare, Send } from 'lucide-react';

export default function ContactFormPreview({ attributes = {} }) {
  return (
    <div style={{ padding: '24px', fontFamily: 'Inter, system-ui, sans-serif' }}>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '12px' }}>
        <ContactField icon={User} placeholder="Your name" />
        <ContactField icon={Mail} placeholder="your@email.com" />
      </div>
      <ContactField icon={Phone} placeholder="Your phone number" />
      <div style={{ marginTop: '12px' }}>
        <div style={{
          padding: '12px', borderRadius: '8px', border: '1px solid #e5e7eb',
          minHeight: '120px', display: 'flex', gap: '10px',
        }}>
          <MessageSquare size={16} style={{ color: '#9ca3af', flexShrink: 0, marginTop: '2px' }} />
          <span style={{ fontSize: '13px', color: '#9ca3af' }}>Tell us how we can help you...</span>
        </div>
      </div>
      <button style={{
        marginTop: '16px', padding: '12px 24px', borderRadius: '8px', border: 'none',
        background: '#111827', color: '#fff', fontSize: '14px', fontWeight: 600,
        cursor: 'default', display: 'flex', alignItems: 'center', gap: '8px',
      }}>
        <Send size={16} /> Send Message
      </button>
    </div>
  );
}

function ContactField({ icon: Icon, placeholder }) {
  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: '10px',
      padding: '10px 12px', borderRadius: '8px', border: '1px solid #e5e7eb',
    }}>
      <Icon size={16} style={{ color: '#9ca3af', flexShrink: 0 }} />
      <span style={{ fontSize: '13px', color: '#9ca3af' }}>{placeholder}</span>
    </div>
  );
}
